// extracted by mini-css-extract-plugin
export default {"button":"headphones_button__jRE6V","images":"headphones_images__ESZaT","ok":"headphones_ok__cvlWC","viewmore":"headphones_viewmore__Ye78D"};